// Test IDs for the Breakdownexperts marketing site.
// Naming follows the project convention: keys camelCase, values kebab-case.

export const HEADER = {
	root: 'header-root',
	brand: 'header-brand',
	callButton: 'header-call-button',
	navServices: 'header-nav-services',
	navHow: 'header-nav-how',
	navCoverage: 'header-nav-coverage',
	navFaq: 'header-nav-faq',
};

export const HERO = {
	root: 'hero-root',
	headline: 'hero-headline',
	subline: 'hero-subline',
	callCta: 'hero-call-cta',
	scrollHint: 'hero-scroll-hint',
};

export const TRUST = {
	root: 'trust-root',
	badgeLicensed: 'trust-badge-licensed',
	badgeAvailability: 'trust-badge-availability',
	badgeCoverage: 'trust-badge-coverage',
};

export const SERVICES = {
	root: 'services-root',
	item: (slug) => `services-item-${slug}`,
};

export const MANIFESTO = {
	root: 'manifesto-root',
	step: (n) => `manifesto-step-${n}`,
};

export const MARQUEE = {
	root: 'marquee-root',
};

export const COVERAGE = {
	root: 'coverage-root',
	map: 'coverage-map',
};

export const TESTIMONIALS = {
	root: 'testimonials-root',
	item: (i) => `testimonials-item-${i}`,
};

export const PRICING = {
	root: 'pricing-root',
	callCta: 'pricing-call-cta',
};

export const FAQ = {
	root: 'faq-root',
	item: (i) => `faq-item-${i}`,
};

export const FOOTER = {
	root: 'footer-root',
	callLink: 'footer-call-link',
	address: 'footer-address',
};

export const FLOATING = {
	callButton: 'floating-call-button',
};
